import { ReactElement, ReactNode } from 'react';
import cx from 'clsx';
import { period, segmentContainer, segmentContent, segmentStateVariants } from './SegmentSpan.css';
import { NewSelectionState, SegmentHandle, SegmentSelectionStateType, SelectionState } from './types';
import { formatInterval } from 'utilities';

export type SegmentState = NewSelectionState['type'] | `${SegmentSelectionStateType['type']}-${SegmentHandle | 'idle'}`;

type SegmentBaseProps = {
  state: SegmentState;
  error?: 'overlap' | null;
  undersized?: boolean;
  misaligned?: boolean;
  left: number;
  width: number;
  start: Date;
  end: Date;

  children: ReactNode;
};

export function selectionTotState(state: SelectionState): SegmentState | undefined {
  if (state === null) {
    return;
  }
  if (state.type === 'selection') {
    return 'selection';
  }
  return segmentSelectionTotState(state);
}

export function segmentSelectionTotState(state: SegmentSelectionStateType): SegmentState {
  return `${state.type}-${state.handle}`;
}

export function SegmentSpan({
  state,
  left,
  width,
  error,
  undersized,
  misaligned,
  children,
  start,
  end,
}: SegmentBaseProps): ReactElement {
  return (
    <div
      className={cx(segmentContainer, segmentStateVariants[state], { error, undersized, misaligned })}
      style={{ left, width }}
    >
      <div className={segmentContent}>{children}</div>
      <div className={period}>{formatInterval(start, end)}</div>
    </div>
  );
}
